import { RenderItemProps, VirtualList } from '@shared/components/ui/VirtualList';
import { useTranslation } from 'react-i18next';
import { ReturnedReception } from '../../models/Reused';
import { ReusedCard } from './ReusedCard';

interface CardListProps {
  reused: ReturnedReception[];
  isLoading?: boolean;
  className?: string;
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  total?: number;
  onPrint?: (item: ReturnedReception) => void;
  onView?: (item: ReturnedReception) => void;
}

export const CardList = ({
  reused,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
  total,
  className = '',
  onPrint,
  onView,
}: CardListProps) => {
  const { t } = useTranslation('reusedModule');

  const renderReusedCard = (props: RenderItemProps<ReturnedReception>) => (
    <ReusedCard {...props} onPrint={onPrint} onView={onView} />
  );

  const getReusedKey = (item: ReturnedReception) => {
    return item.id;
  };

  return (
    <VirtualList
      data={reused}
      renderItem={renderReusedCard}
      itemKey={getReusedKey}
      estimateItemHeight={140}
      height="calc(100vh - 180px)" // Ajuste para el header y filtros
      gap={0}
      emptyMessage={t('empty.message', 'No se encontraron recepciones')}
      className={`rounded-lg ${className}`}
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      infiniteScrollThreshold={200}
      total={total}
      listClassName="touch-pan-y"
      itemClassName="touch-manipulation px-1"
    />
  );
};
